module.exports = __webpack_public_path__ + "static/media/apollor_diagnostics_titagarh.d89b2a2d.png";